import PopupRoot_ResponsiveComponent from '../components/PopupRoot/viewer/skinComps/Responsive/Responsive.skin';


const PopupRoot_Responsive = {
  component: PopupRoot_ResponsiveComponent
};


export const components = {
  ['PopupRoot_Responsive']: PopupRoot_Responsive
};

